export const ShowingServiceEndpoints = {
    addShowing: () => '/signup_service/showing',
    deleteShowing: (showingId: string) => `/signup_service/showing/${showingId}`,
    attendedShowing: (stageId: string) => `/signup_service/showing/attended/${stageId}`,
};
